import React, { useState, useEffect } from "react";
import axios from "axios";

function Adventures() {
  const [images, setImages] = useState([]);
  const [load, setLoad] = useState(false);
  const [filter, setFilter] = useState([]);
  const [tags, setTags] = useState([]);
  const [sort, setSort] = useState([]);

  useEffect(() => {
    refreshImages()
    refreshTags()
  }, [])

  useEffect(() => {
    sortImages();
  }, [filter])

  useEffect(() => {
    sortImages();
  }, [images])

  const refreshImages = () => {
    axios.get("./api/adventures").then(({ data }) => {
      setImages(data)
    })
  }

  const refreshTags = () => {
    axios.get("./api/tags").then(({ data }) => {
      setTags(data)
    })
  }

  const sortImages = () => {
    let newSort = [];
    if (filter.length < 1) {
      setSort(images);
    } else {
      filter.forEach(f => {
        images.filter(image => {
          const tags = image.tags.map(tag => tag.name);
          if (tags.indexOf(f) > -1 && newSort.indexOf(image) < 0) {
            newSort.push(image);
          }
          if (tags.indexOf(f) < 0 && newSort.indexOf(image) > -1) {
            newSort = newSort.filter(a => a !== image);
          }
        })
      })
      setSort(newSort);
    }
  }

  const openMenu = () => {
    const menu = document.querySelector(".uploadBg");
    menu.style.display = "flex"
  }

  const closeMenu = () => {
    const menu = document.querySelector(".uploadBg");
    menu.style.display = "none";
    document.querySelector("#imgCaption").value = "";
    document.querySelector("#imgFile").value = "";
    document.querySelector(".imgPreview").src = "";
  }

  const imgUpload = () => {
    const files = document.querySelector("#imgFile").files;
    if (files.length < 1) {
      flashWarning();
      return;
    }

    setLoad(true);
    const caption = document.querySelector("#imgCaption").value;
    const tags = document.querySelector("#imgTags").value
    const formData = new FormData();
    formData.append("image", files[0], caption + "!@#DIVIDER#@!" + tags);

    axios.post("./api/adventures", formData)
      .then(data => {
        setLoad(false);
        closeMenu();
        refreshImages();
      })
      .catch(err => console.log(err))
  }

  const loadPreview = (event) => {
    const image = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const img = document.querySelector(".imgPreview");
      img.src = fileReader.result;
    }
    fileReader.readAsDataURL(image);
  }

  const flashWarning = () => {
    const warning = document.querySelector(".warning");
    for (let i = 0; i < 10; i++) {
      setTimeout(() => {
        if (i % 2 === 0) {
          warning.style.display = "block";
        } else {
          warning.style.display = "none";
        }
      }, i * 500)
    }
  }

  const imgPopup = (event) => {
    const img = event.target;
    const i = img.dataset.id;
    const targetImg = document.querySelector(".popupImg img");
    const targetCaption = document.querySelector(".popupBg .caption");
    targetImg.src = sort[i].filename;
    targetCaption.innerHTML = sort[i].caption;
    document.querySelector(".popupBg").style.display = "block";
  }

  const closePopup = () => {
    const popup = document.querySelector(".popupBg");
    popup.style.display = "none";
    document.querySelector(".popupImg img").src = "";
    document.querySelector(".popupBg .caption").innerHTML = "";
  }

  const loadingScreen = () => {
    if (load) {
      return <div id="loadingScreen">Uploading...</div>
    } else {
      return <div></div>
    }
  }

  const addTag = (event) => {
    const target = event.target;
    const tag = target.options[target.selectedIndex].text;
    if (filter.indexOf(tag) === -1) {
      setFilter([tag, ...filter]);
    }
    target.value = "Select Tags"
  }

  const removeTag = event => {
    const target = event.target;
    const tag = target.textContent.split(" ")[0];
    const newFilter = filter.filter(filter => filter !== tag);
    setFilter(newFilter);
  }
  return (
    <div id="adventures">
      <h1>Derp Adventures</h1>
      {loadingScreen()}
      <div id="tags">
        <div className="upload" onClick={openMenu}><img src="./images/upload.svg" /></div>
        <select name="tags" id="tags" onChange={addTag} value="Select Tags">
          <option disabled>Select Tags</option>
          {tags.map((tag, i) => {
            return <option value={tag.name} key={"option " + i}>{tag.name}</option>
          })}
        </select>
        <div className="tagList">
          {filter.map((tag, i) => {
            return <div className="tag" onClick={removeTag} key={"list " + i}>{tag} &times;</div>
          })}
        </div>
      </div>
      <div className="popupBg" onClick={closePopup}>
        <div className="popupImg">
          <span className="closePopup" onClick={closePopup}>&times;</span>
          <img loading="lazy" src=""></img>
        </div>
        <div className="caption"></div>
      </div>
      <div className="uploadBg">
        <div className="uploadMenu">
          <div className="warning">Select an image to upload!</div>
          <span className="closeMenu" onClick={closeMenu}>&times;</span>
          <div className="imgPreviewContainer">
            <img className="imgPreview" />
          </div>
          <label htmlFor="imgFile" className="imgFile">Select Image</label>
          <input type="file" id="imgFile" onChange={loadPreview}></input>
          <label>Caption</label>
          <textarea id="imgCaption" placeholder="Tell us about your adventure!"></textarea>
          <label>Tags</label>
          <textarea id="imgTags" placeholder="add single word tags separated by spaces"></textarea>
          <label id="imgUpload" onClick={imgUpload}>Upload</label>
        </div>
      </div>
      <div className="collage">
        <div className="stickyTop"></div>
        <div className="col">
          {sort.map((img, i) => {
            if (i % 4 === 0) {
              return <img loading="lazy" src={img.filename.replace("upload", "upload/t_optimize").replace(".jpg", "")} key={i} data-id={i} onClick={imgPopup} />
            }
          })}
        </div>
        <div className="col">
          {sort.map((img, i) => {
            if (i % 4 === 1) {
              return <img loading="lazy" src={img.filename.replace("upload", "upload/t_optimize").replace(".jpg", "")} key={i} data-id={i} onClick={imgPopup} />
            }
          })}
        </div>
        <div className="col">
          {sort.map((img, i) => {
            if (i % 4 === 2) {
              return <img loading="lazy" src={img.filename.replace("upload", "upload/t_optimize").replace(".jpg", "")} key={i} data-id={i} onClick={imgPopup} />
            }
          })}
        </div>
        <div className="col">
          {sort.map((img, i) => {
            if (i % 4 === 3) {
              return <img loading="lazy" src={img.filename.replace("upload", "upload/t_optimize").replace(".jpg", "")} key={i} data-id={i} onClick={imgPopup} />
            }
          })}
        </div>
        <div className="col showMobile">
          {sort.map((img, i) => {
            return <img loading="lazy" src={img.filename.replace("upload", "upload/t_optimize").replace(".jpg", "")} key={i} data-id={i} onClick={imgPopup} />
          })}
        </div>
        <div className="stickyBottom"></div>
      </div>
    </div>
  )
}

export default Adventures;